/* eslint-disable @typescript-eslint/no-empty-function */
import { createContext, Dispatch, SetStateAction } from 'react';
import { Montagem } from '../components/Insumos/DialogInsumos';

interface MontagemProps {
  montagens: Montagem[];
  getMontagem: (cd: string) => void;
  handleClose: () => void;
  setMontagens: Dispatch<SetStateAction<Montagem[]>>;
  setAddMontagem: Dispatch<SetStateAction<boolean>>;
  addMontagem: boolean;
  setCurrentCd: Dispatch<SetStateAction<number>>;
  currentCd: number;
}
export const MontagemContext = createContext<MontagemProps>({
  montagens: [
    {
      cd: 0,
      focus: false,
      nm: '',
      ordem: 0,
      qtd_max: 0,
      qtd_min: 0,
      qtd_promo: 0,
      titulo: '',
    } as Montagem,
  ],
  getMontagem: () => { },
  handleClose: () => { },
  setMontagens: () => { },
  setAddMontagem: () => { },
  setCurrentCd: () => { },
  addMontagem: false,
  currentCd: -1,
});
